<template>
  <div class="main">
    <div v-for="(item, index) in showData.value" :key="index">
      <div
        v-if="index % 3 == 0"
        class="info"
        :class="{
          info1: item.ranking == 1,
          info2: item.ranking == 2,
          info3: item.ranking == 3,
        }"
      >
        <span class="ranking">{{ item.ranking }}</span>
        <span class="org">{{ item.org }}</span>
        <span class="playerName"
          >{{ showData.value[index + 1].playerName }}/{{
            showData.value[index + 2].playerName
          }}</span
        >
      </div>
    </div>
  </div>
</template>

<script>
import { ref, computed, reactive, toRefs } from "vue";
import { useRouter } from "vue-router";
import { createState } from "../../store";
export default {
  setup() {
    const data = reactive(createState);
    return {
      state: reactive(createState),
    };
  },
  props: {
    //指定接收的值，必须指定类型
    showData: Object,
  },
  methods: {},
  mounted() {},
  created() {},
  computed: {},
};
</script>

<style lang="less" scoped>
.award {
  width: 100%;
  height: 100%;
}
.info {
  width: 7rem;
  height: 1rem;
  margin-left: 0.3rem;
  color: #ccc;
  span {
    display: inline-block;
    font-size: 0.34rem;
    text-align: center;
    font-weight: 900;
    height: 1rem;
    overflow: hidden;
    line-height: 1rem;
  }

  .ranking {
    width: 1rem;
  }
  .org {
    width: 2.5rem;
    word-break: keep-all; /* 不换行 */
    white-space: nowrap; /* 不换行 */
    overflow: hidden; /* 内容超出宽度时隐藏超出部分的内容 */
    text-overflow: ellipsis; /* 当对象内文本溢出时显示省略标记(...) ；需与overflow:hidden;一起使用。*/
  }
  .playerName {
    width: 3.5rem;
    word-break: keep-all; /* 不换行 */
    white-space: nowrap; /* 不换行 */
    overflow: hidden; /* 内容超出宽度时隐藏超出部分的内容 */
    text-overflow: ellipsis; /* 当对象内文本溢出时显示省略标记(...) ；需与overflow:hidden;一起使用。*/
  }
}
.info1 {
  color: #ffff00;
}
.info2 {
  color: #fff;
}
.info3 {
  color: #cc9933;
}
</style>
